module.exports = __webpack_public_path__ + "assets/img/peripheral.1d8c37df.png";